import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { ResizeService } from 'src/app/shared/resize.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetEmailModel } from '../model/auth.model';

@Component({
  selector: 'app-reset-email',
  templateUrl: './reset-email.component.html',
  styleUrls: ['./reset-email.component.scss'],
  standalone: false,
})
export class ResetEmailComponent implements OnInit {
  msg!: string;
  resetEmailForm!: FormGroup;
  isLoading$: Observable<boolean> | undefined;
  error: unknown;
  screenType!: string;
  uid: string | null = null;
  token: string | null = null;
  data: string | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private resizeService: ResizeService
  ) {
    this.isLoading$ = this.authService.isLoading$;
    this.uid = this.route.snapshot.paramMap.get('uid');
    this.data = this.route.snapshot.paramMap.get('data');
    this.token = this.route.snapshot.paramMap.get('token');
    this.resizeService.screenWidthChange$.subscribe({
      next: (res: string) => {
        this.screenType = res;
      },
    });
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.resetEmailForm = this.fb.group({
      new_email: [this.data, [Validators.required, Validators.email]],
    });
  }

  resetEmail() {
    const resetEmailModel: ResetEmailModel = {
      uid: this.uid ?? '',
      token: this.token ?? '',
      data: this.data ?? '',
    };

    this.authService.resetEmail(resetEmailModel).subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.error = err;
      },
    });
  }
}
